export default __webpack_public_path__ + "static/media/iconCard3.abd1edb8.svg";